import { gql } from "@apollo/client"

const CHECKBOX_JOB_STEP_FIELDS = gql`
  fragment CheckboxJobStepFields on CheckboxJobStep {
    id
    step
    number
    section
    name
    responseType
    responseMandatory
    response
    description
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
  }
`

export { CHECKBOX_JOB_STEP_FIELDS }
